import * as React from 'react';
import { CharacteristicGroupDataService, SurveyVersionDataService, SurveyReportTypeDataService } from '../../services';
import { CharacteristicGroup, SurveyVersion, SurveyReportType } from '../../models';
import { NavLink } from 'react-router-dom';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { DataGrid } from '../../components';
import { UserStore, FilterStore } from '../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';

interface CharacteristicGroupListingProps extends BaseRouteProps<{ id: number }> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

interface CharacteristicGroupListingState extends ListingState<CharacteristicGroup> {
    surveyIsPublished: boolean;
    surveyReportTypeID: number;
    reportTypes: SurveyReportType[];
}

@inject('UserStore', 'FilterStore') @observer
export class CharacteristicGroupListing extends React.Component<CharacteristicGroupListingProps, CharacteristicGroupListingState> {
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);
    private surveyReportTypeDataService = new SurveyReportTypeDataService(this.props.notificationService);

    @computed get isSuperAdmin() {
        return this.props.UserStore!.userRoleIn(['superAdmin']);
    }

    constructor(props: CharacteristicGroupListingProps) {
        super(props);

        this.state = {
            entities: new Array<CharacteristicGroup>(),
            surveyIsPublished: true,
            surveyReportTypeID: -1,
            reportTypes: []
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.match.params.id).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.characteristicGroupDataService.getAllBySurveyVersion(surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                this.setState({
                    entities: characteristicGroups
                });
            });
        });

        this.surveyReportTypeDataService.getBySurveyVersion(this.props.match.params.id).then((rts: SurveyReportType[]) => {
            var rtID = -1;
            if (rts.length > 0) {
                rtID = rts[0].id;
            }
            this.setState({
                reportTypes: rts,
                surveyReportTypeID: rtID
            });
        });
    }

    public render() {
        const listData = this.state.entities.sort((a: CharacteristicGroup, b: CharacteristicGroup) => {
            if (a.sort > b.sort) {
                return 1;
            } else if (a.sort < b.sort) {
                return -1;
            }

            return 0;
        }).filter((cg: CharacteristicGroup) => {
            if (cg.secondaryReportID) {
                return false;
            }
            if (this.state.surveyReportTypeID === -1) {
                return true;
            }
            return cg.surveyReportTypeID === this.state.surveyReportTypeID;
        }).sort((a: CharacteristicGroup, b: CharacteristicGroup) => {
            if (a.secondaryReportID !== undefined && b.secondaryReportID !== undefined) {
                if (a.secondaryReportID > b.secondaryReportID) {
                    return 1;
                } else if (a.secondaryReportID < b.secondaryReportID) {
                    return -1;
                }
            }

            return 0;
        }).map(entity => {
            return {
                'Name': entity.name,
                'Report': entity.surveyReportType && entity.surveyReportType.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <NavLink className="btn btn-default btn-block" to={`/characteristicgroup/${value}`}>View</NavLink>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'Report' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="row">
                            <div className="col-xs-7">
                                <div className="title">
                                    <NavLink to={'/surveyversion/' + this.props.match.params.id}>
                                        <span className="glyphicon glyphicon-triangle-left" />
                                    </NavLink>
                                    &nbsp;
                                    Characteristic Groups
                                </div>
                            </div>
                            {(this.isSuperAdmin) &&
                                <div className="col-xs-5 text-right">
                                    <NavLink className="btn btn-primary" to={'/surveyversion/' + this.props.match.params.id + '/characteristicgroups/create'}>
                                        <span className="glyphicon glyphicon-plus" /> Create
                                </NavLink>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <div>
                            <h5>Filter Report Type</h5>
                            <select className="form-control" value={this.state.surveyReportTypeID} onChange={(e) => this.setState({surveyReportTypeID: parseInt(e.target.value, 10)})}>
                                <option value={-1}>[No Filter]</option>;
                                {this.state.reportTypes.sort((rt1: SurveyReportType, rt2: SurveyReportType) => {
                                    if (rt1.sort > rt2.sort) { return 1; }
                                    if (rt1.sort < rt2.sort) { return -1; }
                                    return 0;
                                }).map((rt: SurveyReportType) => {
                                    return <option key={`rt-${rt.id}`} value={rt.id}>{rt.name}</option>;
                                })}
                            </select>
                        </div>
                        <hr />
                        <DataGrid entities={listData} columns={columnDefs} sortProperties={[{id: 'Report', sortAscending: false}]} />
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/characteristicgroup/CharacteristicGroupListing.tsx